import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-6 py-8 md:py-10">
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-accent-100/60 border border-background-200/70 hover:border-accent-300 transition-all duration-300 group cursor-pointer"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200/70 transition-colors">
              <i className={`${cat.icon} text-accent-600 text-xl md:text-2xl w-6 h-6 md:w-7 md:h-7 flex items-center justify-center`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}